import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { ISubcategoryContext, SubcategoryContext } from '../../subcategoryState/subcategoryContext';
import { SubcategoriesByCustomerList } from './SubcategoriesByCustomerList';
import { SubcategoriesByRestaurantList } from './SubcategoriesByRestaurantList';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Subcategories.module.scss';

export const Subcategories: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, subcategoriesByCustomer, subcategoriesByRestaurant, currentPage, countOfItems } =
		useContext<ISubcategoryContext>(SubcategoryContext);

	return (
		<>
			{subcategoriesByCustomer.totalCount || subcategoriesByRestaurant.totalCount ? (
				<div className={style.container} data-test="Subcategories">
					{!!subcategoriesByCustomer.totalCount && <SubcategoriesByCustomerList />}
					{!!subcategoriesByRestaurant.totalCount && <SubcategoriesByRestaurantList />}
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={subcategoriesByCustomer.totalCount || subcategoriesByRestaurant.totalCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};
